import AdvancedController from "../../../lib/controllers/advanced-controller"

/**
 * Generated Base Controller for TableWrapperController
 **/
export class TableWrapperBaseController extends AdvancedController {
  static targets = []

  static values = {
    "conditionals": Array,
  }

  
}